<template>
  <div id="admin-config-navigation">
    <div id="mobile-navigation">
      <div class="drawer-handle" @click="toggleMobileDrawer">
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          :class="mobileDrawerActive ? 'right' : 'left'"
        >
          <path
            d="M15.625 20.3125L7.8125 12.5L15.625 4.6875"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <div class="navigation-items" v-if="mobileDrawerActive">
        <p
          class="navigation-item"
          v-for="(route, index) in routes"
          :key="index"
          @click="navigate(route)"
        >
          {{ route.navigation }}
        </p>
      </div>
    </div>
    <div id="desktop-navigation">
      <p
        class="navigation-item"
        v-for="(route, index) in routes"
        :key="index"
        @click="navigate(route)"
      >
        {{ route.navigation }}
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      categories: [
        "Identity",
        "Services",
        "Packages",
        "Add-Ons",
        "Adustments",
        "Automations",
        "Forms",
        "Contracts",
        "Payments",
        "Subscription",
      ],
      mobileDrawerActive: false,
    };
  },
  computed: {},
  methods: {
    toggleMobileDrawer() {
      this.mobileDrawerActive = !this.mobileDrawerActive;
    },
    navigate(category) {
      if (this.mobileDrawerActive) {
        this.toggleMobileDrawer();
      }
      this.$emit("navigate", category);
    },
  },
  created() {},
  components: {},
  props: ["routes"],
  emits: ["navigate"],
};
</script>
<style scoped>
@media screen {
  #desktop-navigation {
    display: none;
  }

  #mobile-navigation {
    position: fixed;
    right: 0;
    top: 0;
    height: 100vh;
    z-index: 2;
    width: fit-content;
    display: flex;
  }

  .drawer-handle {
    width: 25px;
    height: 100%;
    display: flex;
    align-items: center;
    background-color: var(--backgroundColor);
    filter: drop-shadow(1px 0px 2px var(--shadow));
    border: 1px solid var(--secondaryColor);
  }

  .navigation-items {
    background-color: var(--backgroundColor);
    padding: 30px 30px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    overflow-y: scroll;
    justify-content: space-evenly;
    flex-direction: column;
  }

  .right {
    transform: rotate(180deg);
  }

  .navigation-item {
    text-align: left;
    margin: 0;
  }

  @media (min-width: 800px) {
    p:hover {
      text-decoration: underline;
    }
    #mobile-navigation {
      display: none;
    }
    #desktop-navigation {
      width: 170px;
      height: 100%;
      position: fixed;
      top: 0;
      right: 0;
      z-index: 2;

      box-sizing: border-box;
      padding: 120px 30px;
      overflow: scroll;

      display: flex;
      justify-content: space-evenly;
      flex-direction: column;

      border-left: 1px solid var(--secondaryColor);
      background-color: var(--backgroundColor);
      text-align: left;
    }
  }
}
</style>
